import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./components/Header";
import BodyTopDestinations from "./components/BodyTopDestinations";
import Footer from "../../../components/footerPage/Footer";
import Hotdeal from "./components/Hotdeal";
import BestSeller from "./components/BestSeller";
import ResetPasswordModal from "../../user/ResetPasswordModal";
import Sail from "../../../Asset/image/yacht/Sail.gif"; // loader gif
import SEO from "../../../components/SEO/SEO";

function HomePage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [verifyId, setVerifyId] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const [promoFilter, setPromoFilter] = useState(null);
  const [isPromoCollapsed, setIsPromoCollapsed] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const selectedLanguage = localStorage.getItem("selectedLanguage");

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleApplyPromo = (promoData) => {
    setPromoFilter(promoData);
    localStorage.setItem("promoFilter", JSON.stringify(promoData));
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("verifyId");
    if (token) {
      setVerifyId(token);
      setIsModalOpen(true);
    }
  }, [location]);

  useEffect(() => {
    const storedPromo = localStorage.getItem("promoFilter");
    if (storedPromo) {
      setPromoFilter(JSON.parse(storedPromo));
    }
  }, []);

  useEffect(() => {
    // จำลองการโหลดข้อมูลหน้า
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000); // 2 วินาทีหรือปรับตามความเหมาะสม

    return () => clearTimeout(timer);
  }, []);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
  document.body.style.overflow = loading ? "hidden" : "auto";
}, [loading]);

  const isEN = selectedLanguage === "en";

  return (
    <>
      <SEO
        title={
          isEN
            ? "Take My Yacht | Luxury Yacht Charter in Thailand"
            : "Take My Yacht | บริการเช่าเรือยอชต์สุดหรูในประเทศไทย"
        }
        description={
          isEN
            ? "Luxury yacht charter services in Thailand with professional crew. Experience private voyages designed for comfort, elegance, and unforgettable journeys."
            : "บริการเช่าเรือยอชต์สุดหรูในประเทศไทย พร้อมลูกเรือมืออาชีพ สัมผัสการเดินทางแบบส่วนตัว ที่ผสานความสะดวกสบาย ความหรูหรา และประสบการณ์ที่น่าจดจำ"
        }
        url="https://takemyyacht.com/"
        schema={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "Take My Yacht",
          url: "https://takemyyacht.com",
        }}
      />

      {loading && (
        <div
          className="loading-overlay"
        >
          <img
            src={Sail}
            alt="Loading..."
            className="img-box"
            draggable={false}
          />
        </div>
      )}

      <div
        style={{ width: "100%", height: "auto" }}
      >
        <Header onApplyPromo={handleApplyPromo} />
        <BodyTopDestinations />
        <Hotdeal
          promoFilter={promoFilter}
          onClear={() => setPromoFilter(null)}
        />
        <BestSeller />
        <Footer />

        {isModalOpen && verifyId && (
          <ResetPasswordModal verifyId={verifyId} onClose={handleCloseModal} />
        )}
      </div>

      {promoFilter && (
        <div
          className="promo-box"
        >
          {/* HEADER */}
          <div
            className="flex-between-center cursor-pointer"
            onClick={() => setIsPromoCollapsed(!isPromoCollapsed)}
          >
            <div className="font-bold">🎉 Promo Applied</div>
            <div
              className="text-bold ml-12 no-select"
            >
              {isPromoCollapsed ? "＋" : "－"}
            </div>
          </div>

          {/* CONTENT */}
          {!isPromoCollapsed && (
            <>
              <div className="text-14 mt-8px">
                <div>
                  <b>Code:</b> {promoFilter?.data?.promotion_code || "-"}
                </div>

                <div>
                  <b>Discount:</b> {promoFilter?.data?.discount_value_promotion}
                  {promoFilter?.data?.discount_promotion === "Percent"
                    ? "%"
                    : " Baht"}
                </div>

                {promoFilter?.value && (
                  <div>
                    <b>Discount:</b> {promoFilter.value}
                    {promoFilter.type === "percent" ? "%" : "฿"}
                  </div>
                )}
              </div>

              <button
                onClick={() => {
                  setPromoFilter(null);
                  localStorage.removeItem("promoFilter");
                }}
                className="btn-primary-full2"
              >
                Remove Promo
              </button>
            </>
          )}

          {/* COLLAPSED VIEW */}
          {isPromoCollapsed && (
            <div className="text-small mt-6 opacity-90">
              <b>{promoFilter?.data?.promotion_code}</b>
            </div>
          )}
        </div>
      )}

      {showScrollTop && (
        <button
          onClick={scrollToTop}
          aria-label="Scroll to top"
          className="fab-button"
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-4px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
          }}
        >
          {/* Chevron Up */}
          <svg
            width="26"
            height="26"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="18 15 12 9 6 15" />
          </svg>
        </button>
      )}
    </>
  );
}

export default HomePage;
